var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgMagic(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M18.496 7.406l1.64 1.64 5.157-5.155-1.64-1.641-5.157 5.156zM16.902 9L5.793 20.156l1.594 1.594 11.156-11.11L16.903 9zM4.2 18.563L22.06.703c.89-.89 2.296-.89 3.187 0l1.594 1.594c.89.89.89 2.297 0 3.187L8.98 23.344c-.89.89-2.296.89-3.187 0L4.199 21.75a2.235 2.235 0 010-3.188z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgMagic);
export default ForwardRef;
